import React from 'react';
import { Link } from 'react-router-dom';
import { NAV_GROUPS, NAV_TOP_LEVEL } from './navItems';
import MobileNavItem from './MobileNavItem';
import MobileAuthControls from './MobileAuthControls';

/**
 * Mobile slide-down nav. Dark-luxury surface to match the desktop bar.
 * Items are grouped by section heading so the long list stays scannable
 * on small screens.
 */
const MobileNav = ({
  isOpen,
  pathname,
  user,
  isPro,
  loading,
  onClose,
  onLogout,
  onGoToAuth,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="md:hidden bg-[#07070d] border-t border-white/5 max-h-[80vh] overflow-y-auto"
      data-testid="mobile-nav"
    >
      <div className="px-4 pt-3 pb-4 space-y-5">
        {NAV_GROUPS.map((group) => (
          <div key={group.label}>
            <p className="text-[10px] uppercase tracking-[0.18em] text-white/40 px-2 mb-1.5">
              {group.label}
            </p>
            <div className="space-y-1">
              {group.items.map((item) => (
                <MobileNavItem
                  key={item.path}
                  item={item}
                  pathname={pathname}
                  user={user}
                  isPro={isPro}
                  onClose={onClose}
                />
              ))}
            </div>
          </div>
        ))}

        {NAV_TOP_LEVEL.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`block px-3 py-2 rounded-md text-sm font-semibold transition-colors ${
              pathname === item.path
                ? 'bg-white/10 text-cyan-300'
                : 'text-white/80 hover:bg-white/5 hover:text-white'
            }`}
            onClick={onClose}
            data-testid={`mnav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
          >
            {item.name}
          </Link>
        ))}

        <div className="pt-3 border-t border-white/10 flex flex-col gap-2">
          <MobileAuthControls
            user={user}
            isPro={isPro}
            loading={loading}
            onLogout={onLogout}
            onGoToAuth={onGoToAuth}
            onClose={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileNav;
